import React from 'react';
import DocumentManager from '../../pages/DocumentManager';

// Wrapper component to embed DocumentManager page in admin dashboard
const DocumentsTab = () => {
  return (
    <div className="documents-tab">
      <DocumentManager />
    </div>
  );
};

export default DocumentsTab;
